/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Dtos_Totp_TotpEnrollmentQrResponseDto } from '../models/Wealthlane_Dtos_Totp_TotpEnrollmentQrResponseDto';
import type { Wealthlane_Totp_TotpEnrollmentVerificationRequestDto } from '../models/Wealthlane_Totp_TotpEnrollmentVerificationRequestDto';
import type { WealthlaneDtos_Totps_TotpEnrollmentResponseDto } from '../models/WealthlaneDtos_Totps_TotpEnrollmentResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TotpEnrollmentService {

    /**
     * @returns Wealthlane_Dtos_Totp_TotpEnrollmentQrResponseDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiTotpEnrollmentQrCode(): CancelablePromise<Wealthlane_Dtos_Totp_TotpEnrollmentQrResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/totp/enrollment/qr-code',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns WealthlaneDtos_Totps_TotpEnrollmentResponseDto OK
     * @throws ApiError
     */
    public static postApiIdentityApiTotpEnrollmentVerify(
requestBody?: Wealthlane_Totp_TotpEnrollmentVerificationRequestDto,
): CancelablePromise<WealthlaneDtos_Totps_TotpEnrollmentResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/totp/enrollment/verify',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
